import { ButtonBase, LinearProgress, Link } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { Column, Columns, Image, Inline, Stack } from '@superdispatch/ui';
import { Alert, TextBox } from '@superdispatch/ui-lab';
import { useMemo } from 'react';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { trackEvent } from 'shared/helpers/Analytics';
import { useDriverPreferences } from 'shared/modules/driver/DriverPreferencesAPI';
import styled from 'styled-components';
import step1Img from './assets/step_1.png';
import step1ImgDark from './assets/step_1_dark.png';
import step2Img from './assets/step_2.png';
import step2ImgDark from './assets/step_2_dark.png';
import step3Img from './assets/step_3.png';
import step3ImgDark from './assets/step_3_dark.png';

const steps = [
  {
    name: 'business_type',
    title: 'Find Better Loads in 3 Steps!',
    image: step1Img,
    imageDark: step1ImgDark,
    progress: 25,
    subtitle: 'Set your preferred pickup and delivery locations.',
  },
  {
    name: 'transport_details',
    title: 'Almost There! 2 Steps Left.',
    image: step2Img,
    imageDark: step2ImgDark,
    progress: 50,
    subtitle: 'Specify your transport type and equipment.',
  },
  {
    name: 'vehicle_details',
    title: 'Last Step to Better Loads!',
    image: step3Img,
    imageDark: step3ImgDark,
    progress: 75,
    subtitle:
      'Set your vehicle preferences for more relevant load suggestions.',
  },
];

const Container = styled.div`
  padding-bottom: 16px;

  &,
  & .MuiButtonBase-root,
  & .MuiPaper-root,
  & .MuiAlert-message {
    width: 100%;
  }
`;

const StyledArrow = styled(ArrowForward)`
  width: 12px;
  height: 12px;
`;

const BorderLinearProgress = styled(LinearProgress)`
  height: 8px;
  border-radius: 4px;
`;

export function LoadSuggestionBenefitsBanner() {
  const { data: driverPreferences, error } = useDriverPreferences();
  const step = useMemo(() => {
    if (error?.message === 'No suggestion preference found') {
      return steps[0];
    }

    return steps.find(
      ({ name }) => name === driverPreferences?.onboarding_step,
    );
  }, [driverPreferences, error]);

  if (!step) {
    return null;
  }

  return (
    <Container>
      <ButtonBase
        aria-label="open driver preferences"
        onClick={() => {
          MobileAppBridge.openDriverPreferences();
          trackEvent('Clicked on the Driver preferences banner', {
            step: step.name,
          });
        }}
      >
        <Alert icon={false} severity="info">
          <Columns space="xsmall" align="center">
            <Column>
              <Stack space="xxsmall" align="left">
                <TextBox display="block" variant="body-semibold" align="left">
                  {step.title}
                </TextBox>
                <BorderLinearProgress
                  variant="determinate"
                  value={step.progress}
                />
                <TextBox display="block" align="left" variant="caption">
                  {step.subtitle}
                </TextBox>

                <Inline verticalAlign="center" space="none">
                  <Link
                    display="block"
                    underline="none"
                    color="primary"
                    align="left"
                    variant="caption"
                  >
                    Set Preferences
                  </Link>

                  <StyledArrow />
                </Inline>
              </Stack>
            </Column>

            <Column width="content">
              <Image
                src={step.image}
                srcDark={step.imageDark}
                alt=""
                height="75"
                width="75"
              />
            </Column>
          </Columns>
        </Alert>
      </ButtonBase>
    </Container>
  );
}
